<template>
  <div :class="$style['service-mobile-navigation']">
    <NuxtLink
      :class="$style['service-mobile-navigation__item']"
      :to="{ name: $lang + '-service' }">
      <b>{{ $t('footer/service') }}</b>
      <span>
        {{ openedText }}
      </span>
    </NuxtLink>
    <NuxtLink
      :class="$style['service-mobile-navigation__item']"
      :to="{ name: $lang + '-giftcards' }">
      <b>{{ $t('footer/giftcards') }}</b>
      <span>
        {{ $t('general/suprice-your-friend-with-giftcard') }}
      </span>
    </NuxtLink>
    <NuxtLink
      :class="$style['service-mobile-navigation__item']"
      :to="{ name: $lang + '-stores' }">
      <b>{{ $t('footer/stores') }}</b>
      <span>
        {{ $t('general/visit-our-store') }}
      </span>
    </NuxtLink>
    <NuxtLink
      :class="$style['service-mobile-navigation__item']"
      :to="{ name: $lang + '-vacancies' }">
      <b>{{ $t('footer/vacatures') }}</b>
      <span>
        {{ $t('general/we-are-looking-for-you') }}
      </span>
    </NuxtLink>
    <NuxtLink
      :class="$style['service-mobile-navigation__item']"
      :to="{ name: $lang + '-contact' }">
      <b>{{ $t('footer/contact') }}</b>
      <span>
        {{ $t('general/do-you-have-questions') }}
      </span>
    </NuxtLink>
  </div>
</template>
<script setup>
const { $t } = useNuxtApp()
const openedText = computed(() => {
  const date = new Date()
  const weekDay = date.getDay()
  const hour = date.getHours()

  if (hour >= 22 || (hour >= 18 && weekDay === 0)) {
    return $t('general/we-will-be-back-tomorrow-1000')
  }

  if (weekDay === 0) {
    return $t('general/open-till-1800')
  }

  return $t('general/open-till-2200')
})
</script>
<style lang="scss" module>
.service-mobile-navigation {
  display: flex;
  flex-direction: column;

  &__item {
    border-top: 1px solid var(--grey-lighter);
    color: var(--grey-darkest);
    display: flex;
    font-size: var(--font-size-s);
    flex-direction: column;
    padding: calc(var(--spacing) * 2);
    text-decoration: none;

    &:hover {
      color: var(--black);
    }

  }
}
</style>
